import dayjs from 'dayjs';
import { IAssembly } from 'src/interfaces';

import { IScheduleWeekdayDaypartRecord } from './TimeRow.interface';

export const hasConflictStartTime = (
  scheduledDayparts: IScheduleWeekdayDaypartRecord[] | undefined,
  weekdayId: number,
  weekdayDaypartId: number,
  startTime: string | null,
  isLocationGroupPage: boolean | undefined,
  groupDaypartsActiveStatus: Record<number, boolean> | undefined,
): boolean => {
  if (!startTime || !scheduledDayparts) return false; // If startTime is null or props.scheduledDayparts is undefined, no conflict

  const startTimeHoursMinutes = startTime.substring(0, 5); // Extract hours and minutes from startTime
  const activeDaypartIds = new Set(
    scheduledDayparts
      .filter((daypart) => daypart.start_time)
      .map((daypart) => daypart.daypart?.id),
  );

  return scheduledDayparts.some((item) => {
    if (
      !isLocationGroupPage &&
      item.daypart?.id !== undefined &&
      groupDaypartsActiveStatus &&
      groupDaypartsActiveStatus[item.daypart.id] === false &&
      !activeDaypartIds.has(item.daypart.id)
    ) {
      return false;
    }

    return (
      item.weekday.id === weekdayId &&
      item.weekday_daypart_id !== weekdayDaypartId &&
      item.start_time?.substring(0, 5) === startTimeHoursMinutes
    );
  });
};

export const toggleDaypartStatus = (
  checked: boolean,
  daypart_id: number,
  scheduledDayparts: IScheduleWeekdayDaypartRecord[] | undefined,
  originalScheduledDayparts: IScheduleWeekdayDaypartRecord[] | undefined,
  daypartRecord: { default_start_time: string },
  setScheduledDayparts: (dayparts: IScheduleWeekdayDaypartRecord[]) => void,
) => {
  if (!scheduledDayparts) return;

  const updatedWeekdayDaypartsRecord = scheduledDayparts?.map((item) => {
    const orgScheduledDaypart = originalScheduledDayparts?.find(
      ({ id }) => id === item.id,
    );

    return item.daypart.id === daypart_id
      ? {
          ...item,
          start_time: checked
            ? orgScheduledDaypart?.start_time ||
              daypartRecord.default_start_time
            : undefined,
        }
      : item;
  });

  setScheduledDayparts(
    updatedWeekdayDaypartsRecord as IScheduleWeekdayDaypartRecord[],
  );
};

export const getAssembliesStatus = (assemblies: IAssembly[] = []) => {
  if (!Array.isArray(assemblies))
    return { scheduleAssembly: null, defaultAssembly: null };

  const now = dayjs();

  const scheduleAssembly =
    assemblies.find(
      (item) => item.startDate && dayjs(item.startDate).isAfter(now),
    ) ?? null;

  const defaultAssembly =
    assemblies.find(
      (item) =>
        !item.startDate ||
        dayjs(item.startDate).isSame(now) ||
        dayjs(item.startDate).isBefore(now),
    ) ?? null;

  return { scheduleAssembly, defaultAssembly };
};
